import "./App.css";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import ProtectedRoute from "./components/ProtectedRoute";
import GuestRoute from "./components/GuestRoute";

import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";

import Home from "./pages/Home";
import CreateOrder from "./pages/CreateOrder";
import Login from "./pages/Login";
import OrderStatus from "./pages/OrderStatus";
import Products from "./pages/Products";
import Profile from "./pages/Profile";
import Wallet from "./pages/Wallet";
import AddFunds from "./pages/AddFunds";
import ProductsByCategory from "./pages/ProductsByCategory";
import OrderDetails from "./pages/OrderDetails";

function App() {
  return (
    <Router>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route element={<GuestRoute />}>
            <Route path="/login" element={<Login />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute />}>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/create-order/:id" element={<CreateOrder />} />
            <Route path="/order-status" element={<OrderStatus />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:categoryId" element={<ProductsByCategory />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/order-details/:orderId" element={<OrderDetails />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/add-funds" element={<AddFunds />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;